<label
  class="file-upload"
  [class.file-upload--dragging]="dragging"
  [class.file-upload--invalid]="invalid"
  [class.file-upload--disabled]="disabled"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave()"
  (drop)="onDrop($event)">
  <input #fileInput type="file" class="file-upload__input" [attr.accept]="accept || null" [disabled]="disabled" (change)="onFileInputChange(fileInput)">

  <svg-icon src="/assets/icons/file-upload.svg" class="file-upload__icon" aria-hidden="true"></svg-icon>

  @if (fileName) {
    <span class="file-upload__file-name">{{ fileName }}</span>
  } @else {
    <span class="file-upload__label">{{ label }}</span>
    @if (hint) {
      <span class="file-upload__hint">{{ hint }}</span>
    }
  }

  @if (uploading) {
    <span class="file-upload__progress" role="progressbar"></span>
  }
</label>
